export default __webpack_public_path__ + "static/media/arbhita.e2afd0d7.png";